export default function formAPIPatientsIPDView({
    appointmentdate,
    appointmenttime,
    admitdate,
    dischargedate,
    doctorname,
    patientname,
    patientimage,
    imagepath,
    patientid,
    appointmentid,
    appointmentstatus,
    appointmentstatusname,
    chiefcomplaint,
    appointmentcurrentstatus,
    appointmenttype,
    paymenttype,
    relation,
    relation_cd,

    patientfirstname,
    patientlastname,
    countrycode,
    countryid,
    gender,
    email,
    emergencycontactname,
    emergencycontactphone,
    emergencycontactcountryid,
    emergencycontactcountrycode,
    
  }) {
   
  
    return Object.freeze({
    appointmentdate,
    appointmenttime,
    admitdate,
    dischargedate,
    doctorname,
    patientname,
    patientimage,
    imagepath,
    patientid,
    appointmentid,
    appointmentstatus,
    appointmentstatusname,
    chiefcomplaint,
    appointmentcurrentstatus,
    appointmenttype,
    paymenttype,
    relation,
    relation_cd,

    patientfirstname,
    patientlastname,
    countrycode,
    countryid,
    gender,
    email,
    emergencycontactname,
    emergencycontactphone,
    emergencycontactcountryid,
    emergencycontactcountrycode,
    });
  }
  